import { Helmet } from "react-helmet-async";
import { styled } from "@mui/material/styles";
import { Divider, Stack, Button, Box } from "@mui/material";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { bgStyles } from "../utils/cssStyles";

export default function Login() {
  const [formHndler, setFormHandler] = useState({ password: "", username: "" });
  const [records, setRecords] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [loder, setLoder] = useState(false);

  const theme = useTheme();

  let URL = window.location.href;
  console.log(URL);
  var match = URL?.match(/companyid=([A-Za-z0-9]+)/);
  useEffect(() => {
    if (match) {
      var companyId = match[1];
      setLoder(true);
      axios
        .post(`/login_sso?companyid=${companyId}`)
        .then((res) => {
          setLoder(false);
          if (
            res["data"]["apicall"] === "success" &&
            res["data"]["msg"] === "Active"
          ) {
            setErrMsg("");
            sessionStorage.setItem("token", res["data"]["apicall"]);
            window.location.replace("/");
          }
        })
        .catch((error) => {
          console.log(error);
          setLoder(false);
          setErrMsg("Somthing Went Wrong!");
        });
    }
  }, []);

  return (
    <>
      <Helmet>
        <title> Login | Support Tool </title>
      </Helmet>
      {loder && <div style={bgStyles}></div>}
    </>
  );
}
